import type { DialogProps } from '@paintscout/ui'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles,
  useTranslation
} from '@paintscout/ui'
import { TileList, useDialogs } from '@paintscout/ui-business'

export interface TileListDialogProps extends DialogProps {
  title: string
  items: {
    key: string
    label: string
    subLabel?: string
  }[]
  onItemSelect: (key: string) => void
  showTopClose?: boolean
}

const useStyles = makeStyles((theme) => ({
  content: {
    paddingBottom: 0
  },
  tileList: {
    paddingTop: theme.spacing(1)
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  dialogPaper: {
    '& .MuiDialogActions-root': {
      display: 'none !important'
    },
    '& .MuiDialogContent-root': {
      paddingBottom: `${theme.spacing(3)}px !important`
    }
  }
}))

export default function TileListDialog({
  title,
  items,
  onItemSelect,
  loading,
  showTopClose,
  ...otherProps
}: TileListDialogProps) {
  const classes = useStyles()
  const { dismissDialog } = useDialogs()
  const { __ } = useTranslation()

  return (
    <Dialog
      {...otherProps}
      maxWidth={'md'}
      fullWidth={true}
      classes={showTopClose ? { paper: classes.dialogPaper } : undefined}
    >
      <DialogTitle
        loading={loading}
        classes={showTopClose ? { root: classes.dialogTitle } : undefined}
        rightContent={
          showTopClose ? (
            <IconButton size="small" onClick={dismissDialog} disabled={loading}>
              <CloseIcon />
            </IconButton>
          ) : undefined
        }
      >
        {title}
      </DialogTitle>
      <DialogContent className={classes.content}>
        <div className={classes.tileList}>
          <TileList
            items={items}
            onSelect={(_, key) => {
              onItemSelect(key as string)
            }}
            subLabelField="subLabel"
          />
        </div>
      </DialogContent>
      {!showTopClose && (
        <DialogActions
          leftButton={
            <Button onClick={dismissDialog} variant="textNoPadding">
              {__('Cancel')}
            </Button>
          }
        />
      )}
    </Dialog>
  )
}
